module.exports = __webpack_public_path__ + "img/selected_regular_fault_in_care.f2675b9f.svg";